export const ROLE_COLORS: Record<string, string> = {
  how_to: "#3b82f6",
  definition: "#22c55e",
  comparison: "#f97316",
  history: "#a855f7",
  troubleshooting: "#ef4444",
  guide: "#06b6d4",
  glossary: "#6b7280",
  commercial: "#eab308",
  protocol: "#ec4899",
};

export const ROLE_LABELS: Record<string, string> = {
  how_to: "How-to",
  definition: "Definicja",
  comparison: "Porownanie",
  history: "Historia",
  troubleshooting: "Troubleshooting",
  guide: "Poradnik",
  glossary: "Slownik",
  commercial: "Komercyjny",
  protocol: "Protokol",
};

export const ENGINE_STAGES = [
  "pending", "serp_research", "kg_assembly", "fan_out",
  "outline_ready", "draft", "optimization", "humanization", "ready", "published", "failed",
] as const;

export const STAGE_LABELS: Record<string, string> = {
  pending: "Oczekuje",
  serp_research: "SERP",
  kg_assembly: "KG",
  fan_out: "Fan-Out",
  outline_ready: "Outline",
  draft: "Draft",
  optimization: "Optymalizacja",
  humanization: "Humanizacja",
  ready: "Gotowy",
  published: "Opublikowany",
  failed: "Blad",
};
